<template>
    <section id="wrapper" class="auth-saas auth-saas--pro">
        <div class="auth-saas__layout auth-saas__layout--centered">
            <div class="auth-saas__form-column">
                <div class="auth-saas__form-inner">
                    <div class="auth-saas__card">
                        <p class="auth-saas__eyebrow">Set new password</p>
                        <h1 class="auth-saas__title">{{ trans('passwords.reset_password') }}</h1>
                        <p class="auth-saas__subtitle">Choose a strong password for your administrator account.</p>
                        <div class="auth-saas__mini-chip">
                            <span class="auth-saas__status-chip-dot" aria-hidden="true"></span>
                            <span>Password reset</span>
                            <kbd>Token</kbd>
                        </div>
                        <div v-if="showMessage" class="auth-saas__alert" :class="status ? 'auth-saas__alert--success' : 'auth-saas__alert--danger'" role="alert">
                            {{ message }}
                        </div>
                        <form v-if="!showMessage" class="form-validate is-alter" id="resetform" @submit.prevent="submit" @keydown="resetForm.errors.clear($event.target.name)">
                            <div class="form-group">
                                <label class="auth-saas__label" for="reset-email">Email</label>
                                <div class="auth-saas__input-wrap">
                                    <admin-icon name="mail" aria-hidden="true"></admin-icon>
                                    <input id="reset-email" type="text" name="email" class="auth-saas__input" autocomplete="email" :placeholder="trans('auth.email')" v-model="resetForm.email">
                                </div>
                                <show-error :form-name="resetForm" prop-name="email" class="text-danger"></show-error>
                            </div>
                            <div class="form-group">
                                <label class="auth-saas__label" for="reset-password">{{ trans('auth.password') }}</label>
                                <div class="auth-saas__input-wrap">
                                    <admin-icon name="lock" aria-hidden="true"></admin-icon>
                                    <input id="reset-password" type="password" name="password" class="auth-saas__input" autocomplete="new-password" :placeholder="trans('auth.password')" v-model="resetForm.password">
                                </div>
                                <show-error :form-name="resetForm" prop-name="password" class="text-danger"></show-error>
                            </div>
                            <div class="form-group">
                                <label class="auth-saas__label" for="reset-password-confirm">{{ trans('auth.confirm_password') }}</label>
                                <div class="auth-saas__input-wrap">
                                    <admin-icon name="lock" aria-hidden="true"></admin-icon>
                                    <input id="reset-password-confirm" type="password" name="password_confirmation" class="auth-saas__input" autocomplete="new-password" :placeholder="trans('auth.confirm_password')" v-model="resetForm.password_confirmation">
                                </div>
                                <show-error :form-name="resetForm" prop-name="password_confirmation" class="text-danger"></show-error>
                            </div>
                            <div class="form-group mb-0">
                                <button class="auth-saas__btn" type="submit" :disabled="resetForm.busy">
                                    <span v-if="resetForm.busy" class="auth-saas__btn-spinner" aria-hidden="true"></span>
                                    <admin-icon name="check" v-else aria-hidden="true"></admin-icon>
                                    <span>{{ trans('passwords.reset_password') }}</span>
                                </button>
                            </div>
                        </form>
                        <div class="auth-saas__note">
                            {{ trans('auth.back_to_login?') }}
                            <router-link to="/login">{{ trans('auth.sign_in') }}</router-link>
                        </div>
                    </div>
                </div>
                <div class="auth-saas__footer">
                    <guest-footer></guest-footer>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import guestFooter from '../../layouts/guest-footer.vue'

    export default {
        data() {
            return {
                resetForm: new Form ({
                    email: '',
                    password: '',
                    password_confirmation: '',
                    token:this.$route.params.token,
                }),
                message: '',
                status: true,
                showMessage: false
            }
        },
        components: {
            guestFooter
        },
        mounted(){
            if(!helper.featureAvailable('reset_password')){
                helper.featureNotAvailableMsg();
                return this.$router.push('/home');
            }

            axios.post('/api/auth/validate-password-reset',{
                token: this.resetForm.token
            }).then(response => {
                this.showMessage = false;
            }).catch(error => {
                this.message = helper.fetchDataErrorMsg(error);
                this.showMessage = true;
                this.status = false;
            });
        },
        methods: {
            submit(e){
                this.resetForm.post('/api/auth/reset').then(response =>  {
                    this.message = response.message;
                    this.showMessage = true;
                    this.status = true;
                }).catch(error => {
                    helper.showErrorMsg(error);
                });
            }
        }
    }
</script>
